import { atom } from 'recoil';
import { Coupon } from '~/types';

const coupon = atom<Coupon | null>({
  key: 'coupon',
  default: null,
});

export default coupon;
